import Button from "components/Button";
import Content from "components/Content";
import Label from "components/Label";
import text from "constants/text";
import Image from "next/image";
import { useRouter } from "next/router";
import React, { FC } from "react";

import styles from "./styles.module.scss";

const Heading: FC = () => {
  const {
    pre_title: preTitle,
    title,
    description,
    cta,
    image
  } = text.partner_network.heading;

  const router = useRouter();

  return (
    <Content
      contentClassName={styles.container}
      containerClassName={styles.wrapper}
    >
      <Label
        variant="s-capitalized-centered"
        color="lightPrimary"
        className={styles.preTitle}
      >
        {preTitle}
      </Label>
      <Label className={styles.title} variant="h-centered" color="lightPrimary">
        {title}
      </Label>
      <Label
        className={styles.description}
        variant="s-centered"
        color="lightPrimary"
      >
        {description}
      </Label>
      <Button variant="cta" onClick={() => router.push(cta.to)}>
        {cta.reads}
      </Button>
      <div className={styles.image}>
        <Image alt="" src={image} layout="fill" objectFit="contain" />
      </div>
    </Content>
  );
};

export default Heading;
